module.exports = __webpack_public_path__ + "static/img/l20.b9f03c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/l20.png
// module id = 4/wB
// module chunks = 0